export default "__VITE_ASSET__CPGJZsee__"